import { apiHubBaseUrl, request } from '@/libs/api-request'

export function getData (params, force) {
  const url = apiHubBaseUrl() + '/v1/journeymap/trend/get_data'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getDashboardTrendData (params, force) {
  let url = apiHubBaseUrl() + '/v1/journeymap/trend/get_dashboard_data'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getMoreData (params, force) {
  const url = apiHubBaseUrl() + '/v1/journeymap/trend/get_data'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getThruTrafficData (params, force) {
  const url = apiHubBaseUrl() + '/v1/journeymap/trend/get_thru_traffic'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getNodeDetail (params, force) {
  const url = apiHubBaseUrl() + '/v1/journeymap/trend/get_node_detail'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getRollbackRefers (params, force) {
  const url = apiHubBaseUrl() + '/v1/journeymap/trend/get_rollback_refers'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getEtcUrls (params, force) {
  const url = apiHubBaseUrl() + '/v1/journeymap/trend/get_etc_urls'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getTrendNodeUsers (params, force) {
  const url = apiHubBaseUrl() + '/v1/journeymap/trend/get_node_users'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}
